import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const DOWNLOAD_AD_UNITS_CONFIGURATION: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation downloadAdUnitsConfiguration($input: DownloadAdUnitsXlsInput!) {
    downloadAdUnitsXls(input: $input) {
      fileData

      errors {
        ...ErrorFragment
      }
    }
  }
`
